module.exports = __webpack_public_path__ + "media/images/mypage/icon/white/ico_image-b743fda75ea11d7047da2cf42532be88.svg";